import { SettingTypes } from '@store/types/settingTypes'

export const settingInitial: SettingTypes = {
  infoDetail: undefined,
  notification: undefined,
  syncConfig: undefined,
  unlocked: false,
  locked: false
}
